"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyLocationInfo = exports.EmptyTimeZoneInfo = void 0;
exports.EmptyTimeZoneInfo = {
    Code: "",
    Name: "",
    GmtOffset: 0,
    IsDaylightSaving: false,
    NextOffsetChange: ""
};
exports.EmptyLocationInfo = {
    Version: 0,
    Key: "",
    Type: "",
    Rank: 0,
    LocalizedName: "",
    EnglishName: "",
    PrimaryPostalCode: "",
    Region: {
        ID: "",
        LocalizedName: "",
        EnglishName: ""
    },
    Country: {
        ID: "",
        LocalizedName: "",
        EnglishName: ""
    },
    AdministrativeArea: {
        ID: "",
        LocalizedName: "",
        EnglishName: "",
        Level: 0,
        LocalizedType: "",
        EnglishType: "",
        CountryID: ""
    },
    TimeZone: exports.EmptyTimeZoneInfo
};
